import { Container as Bs5Grid } from 'react-bootstrap5';

export default Bs5Grid;
